// extracted by mini-css-extract-plugin
module.exports = {"autoSuggest":"CompanyPicker_autoSuggest__2zB5z"};